module.exports = __webpack_public_path__ + "img/hopways.126b1021.jpg";